// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__3alLd","greenDot":"styles_greenDot__oaUxZ","count":"styles_count__Ij3OR"};